export default class BaseFilterParser {
    type;
    elasticKey;
    constructor(type, elasticKey) {
        this.type = type;
        this.elasticKey = elasticKey;
    }
    assertType(metadata) {
        return metadata && metadata.type === this.type;
    }
    getFieldName(subject) {
        return Object.keys(subject)[0];
    }
    /**
     * Parse elastic filter to Kibana filter metadata
     */
    getMetadata(filter, negate = false, indexPattern) {
        throw new Error('MUST OVERRIDE');
    }
    /**
     * Parse elastic filter to Kibana filter
     */
    getFilter(metadata) {
        throw new Error('MUST OVERRIDE');
    }
}
//# sourceMappingURL=base-filter-parser.js.map